import { ReactElement } from 'react';

export interface LoadingProps {
  centered?: boolean;
}

/**
 * Loading is a Mui CircularProgress spinner to indicate loading.
 */
export function Loading({ centered = true }: Readonly<LoadingProps>): ReactElement<LoadingProps> {
  return (
    <div className={centered ? 'flex items-center justify-center py-6' : 'p-6'}>
      <div
        className="border-3 inline-block size-8 animate-spin rounded-full border-solid border-current border-e-transparent align-[-0.125em] text-green-200 motion-reduce:animate-[spin_1.5s_linear_infinite]"
        role="progressbar"
      ></div>
    </div>
  );
}
